import { deltaTone, formatDelta, formatNumber } from "./util";

interface DynamicsBlock {
  mu_lat_front?: number;
  mu_lat_rear?: number;
  estimated_lat_g?: number;
  spring_support_index?: number;
  damper_match_index?: number;
  brake_heat_load_index?: number;
  brake_capacity_index?: number;
  chassis_stiffness_margin?: number;
  camber_deficit_front_deg?: number;
  camber_deficit_rear_deg?: number;
  tire_grip_tier?: string;
}

interface DynamicsDelta {
  mu_lat_front?: number;
  mu_lat_rear?: number;
  estimated_lat_g?: number;
  spring_support_index?: number;
  damper_match_index?: number;
  brake_heat_load_index?: number;
}

interface DynamicsPayload {
  dynamics?: {
    baseline?: DynamicsBlock;
    modified?: DynamicsBlock;
    deltas?: DynamicsDelta;
  };
}

const GAUGES: { key: keyof DynamicsBlock; label: string; digits?: number }[] = [
  { key: "mu_lat_front", label: "前轴 μ", digits: 2 },
  { key: "mu_lat_rear", label: "后轴 μ", digits: 2 },
  { key: "estimated_lat_g", label: "lat g", digits: 2 },
  { key: "spring_support_index", label: "弹簧支撑", digits: 2 },
  { key: "damper_match_index", label: "阻尼匹配", digits: 2 },
  { key: "brake_heat_load_index", label: "刹车热负荷", digits: 2 },
  { key: "brake_capacity_index", label: "刹车容量", digits: 2 },
  { key: "chassis_stiffness_margin", label: "底盘刚度余量", digits: 2 },
  { key: "camber_deficit_front_deg", label: "前 camber 不足", digits: 2 },
  { key: "camber_deficit_rear_deg", label: "后 camber 不足", digits: 2 },
];

export function DynamicsPanel({ payload }: { payload: unknown }) {
  const dyn = (payload as DynamicsPayload)?.dynamics;
  if (!dyn) {
    return <p className="muted small">没有动力学数据。</p>;
  }
  const baseline = dyn.baseline ?? {};
  const modified = dyn.modified ?? {};
  const deltas = dyn.deltas ?? {};
  return (
    <div className="dynamics-grid">
      {GAUGES.map((g) => {
        const before = baseline[g.key];
        const after = modified[g.key];
        const delta = (deltas as Record<string, number | undefined>)[g.key as string];
        const tone = deltaTone(delta);
        return (
          <div key={g.key} className={`dynamics-cell tone-${tone}`}>
            <p className="dynamics-cell-label">{g.label}</p>
            <p className="dynamics-cell-value">
              <span>{formatNumber(after, g.digits)}</span>
              <small className="muted">
                from {formatNumber(before, g.digits)}
              </small>
            </p>
            {typeof delta === "number" ? (
              <p className="dynamics-cell-delta">{formatDelta(delta, g.digits)}</p>
            ) : null}
          </div>
        );
      })}
      {modified.tire_grip_tier ? (
        <div className="dynamics-cell tone-flat">
          <p className="dynamics-cell-label">轮胎档位</p>
          <p className="dynamics-cell-value">
            <span>{modified.tire_grip_tier}</span>
            {baseline.tire_grip_tier && baseline.tire_grip_tier !== modified.tire_grip_tier ? (
              <small className="muted">from {baseline.tire_grip_tier}</small>
            ) : null}
          </p>
        </div>
      ) : null}
    </div>
  );
}
